import Link from 'next/link'

export default function SingleProduct({
    product,
    image,
    description,
    buttonText = 'Shop Now',
}) {
    const summary = description || product.post_excerpt || product.post_content

    return (
        <div className="xl:w-1/4 md:w-1/3 md:flex md:flex-col items-center md:m-0 m-6 overflow-hidden rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)] border-2 border-[#ed5c2f]">
            {image && (
                <div className="">
                    <Link href={`/product/${product.post_name}`}>
                        <img
                            className="h-60 w-full object-cover cursor-pointer"
                            src={image?.url}
                            alt={image?.alt}
                            title={image?.title}
                        />
                    </Link>
                </div>
            )}

            <div className="md:flex h-full pb-px px-px ">
                <div className="bg-white flex flex-col justify-between rounded-b-[20px] xl:px-6 xl:py-6 px-4 py-8 md:py-4 space-y-10 md:space-y-4">
                    <Link href={`/product/${product.post_name}`}>
                        <a className="block space-y-2">
                            <p className="text-xl font-bold">
                                {product.post_title}
                            </p>
                            {summary && (
                                <div
                                    className="text-lg"
                                    dangerouslySetInnerHTML={{
                                        __html: summary,
                                    }}
                                />
                            )}
                        </a>
                    </Link>
                    <Link href={`/product/${product.post_name}`}>
                        <button className="w-full olm-gradient p-4 rounded-md shadow text-center text-[#fffbf9] text-lg/5 font-semibold  ">
                            {buttonText}
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
}
